import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vi-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViEmptyComponent {
  @Input()
  header: string;

  @Input()
  content: string;

  @Input()
  redirectBtn: string;

  @Input()
  redirectLink: string;

  @Input()
  imgSrc: string;

  constructor() {}
}
